import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import type { Module } from "owa-workloads-module";

export interface SET_MODULE_CONTEXT_MAILBOXINFOActionMessage {
    module: Module;
    mailboxInfo: MailboxInfo;
}
const defaultExport: (module: Module, mailboxInfo: MailboxInfo) => SET_MODULE_CONTEXT_MAILBOXINFOActionMessage = action("SET_MODULE_CONTEXT_MAILBOXINFO", (module: Module, mailboxInfo: MailboxInfo): SET_MODULE_CONTEXT_MAILBOXINFOActionMessage => ({
    module,
    mailboxInfo,
}));
export default defaultExport;
